export default __webpack_public_path__ + "static/media/gas.c8cd9c31.png";